import { citations, reactions, substances, tgitems } from '@Constants';

export const zoomReducerKey = 'zoomReducer';

export const setZoomValueType = 'setZoomValueType';

export const ZOOM_STORAGE_KEY = 'zoomLevel';

const defaultZoomLevels = ['small', 'medium', 'large'];
const resultsClasses = ['substance-image-small', 'substance-image-medium', 'substance-image-large'];
const synthesisClasses = ['synthesis-planner-workspace-small', 'synthesis-planner-workspace-medium', 'synthesis-planner-workspace-large'];

export const zoomSliderLevels = {
  defaultValue: 0,
  defaultForKey: {
    'default': 0,
    [citations]: 0,
    [reactions]: 0,
    [substances]: 0,
    [tgitems]: 0,
    'synthesis-planner': 1,
  },
  min: 0,
  max: 2,
  step: 1,
};

export const zoomClasses = {
  'default': defaultZoomLevels,
  [citations]: resultsClasses,
  [reactions]: resultsClasses,
  [substances]: resultsClasses,
  [tgitems]: resultsClasses,
  'synthesis-planner': synthesisClasses,
};
